<template>
  <div class="add-lockcourse">
    <el-form :model="ruleForm" label-width="130px" :rules="rules" ref="formName" class="wrapper">
      <div class="add">
        <base-title :title="`表单控件管理`"></base-title>
        <div class="info-template">
          <el-form-item label label-width="0" prop="form_control_name">
            <el-input v-model="ruleForm.form_control_name" class="w220" placeholder="输入添加的名称"></el-input>
            <span class="ml10 mr20 b">:</span>
            <el-radio-group v-model="ruleForm.choose">
              <el-radio label="0">下拉选项</el-radio>
              <el-radio label="1">日期选择</el-radio>
              <el-radio label="2">仅限数字</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label label-width="0" v-if="ruleForm.choose==0" prop>
            <span class="ml10 mr20 w220 iblock"></span>
            <el-input
              ref="option"
              type="textarea"
              placeholder="选项之间用英文逗号隔开"
              v-model="ruleForm.form_control_option"
              :autosize="{ minRows: 3, maxRows: 3 }"
              class="options"
            ></el-input>
            <div class="el-form-item__error">请添加正确的下拉选项</div>
          </el-form-item>

          <el-form-item label label-width="0">
            <span class="ml10 mr20 w220 iblock"></span>
            <el-checkbox label="必填" v-model="ruleForm.must_complete"></el-checkbox>
          </el-form-item>
        </div>
        <div class="info-add">
          <el-button type="primary" @click="addCourseInfo('ruleForm')">添加</el-button>
        </div>
      </div>

      <div class="all-info mt20">
        <div class="space"></div>
        <el-row>
          <el-form-item
            :label="`${item.form_control_name}：`"
            v-for="(item,index) in def_data"
            :key="index"
            label-width="80"
          >
            <template v-if="item.form_control_type=='select'">
              <el-select v-model="item.model" placeholder="请选择" class="w220">
                <el-option
                  v-for="(item,index) in item.arr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>

            <template v-if="item.form_control_type=='text'">
              <el-input v-model="item.value" class="w220"></el-input>
            </template>

            <template v-if="item.form_control_type=='email'">
              <el-input v-model="item.value" class="w220"></el-input>
            </template>
            <template v-if="item.form_control_type=='mobile'">
              <el-input v-model="item.phone" class="w220"></el-input>
            </template>

            <template v-if="item.form_control_type=='date'">
              <el-date-picker v-model="item.date" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </template>
            <template v-if="item.form_control_type=='number'">
              <el-input class="w220" v-model="item.value" @change="numerHandleChange"></el-input>
            </template>
            <i class="el-icon-delete ml20 blue" @click="delDefInfo(item,index)"></i>
          </el-form-item>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import Title from "@/views/course/play-template/title.vue";

import {
  _formControlAdd,
  _formControlRemove,
  _formControlList
} from "@/api/user.js";
import qs from "qs";

export default {
  created() {
    this.initControlList();
  },
  components: {
    "base-title": Title
  },
  data() {
    return {
      def_data: [],
      //添加选项框的数据
      ruleForm: {
        choose: "0", //选择添加的选项
        form_control_name: "", //控件的名称
        form_control_type: "", //控件类型
        form_control_option: "", //控件选项数组或者对象
        must_complete: false, //必填,1:必填;2:非必填
        is_default: "1", //设置表单时是否默认 1:默认 0:正常
        arr: [], //select
        number: "", //number
        date: "", //string
        phone: "", //text
        id: ""
      },
      rules: {
        form_control_name: [
          { required: true, message: "添加信息的名称", trigger: "blur" }
        ],
        form_control_option: [
          { required: true, message: "选项的名称", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  methods: {
    numerHandleChange(val) {
      console.log(val);
    },
    addCourseInfo(formName) {
      this.$refs["formName"].validate(valid => {
        if (valid) {
          //加下拉选项的选择
          if (this.ruleForm.form_control_option === "") {
            console.log(this.$refs);
            this.$refs.option.focus();
            this.$message.error("请填写下拉选项的选项");
            return false;
          }
          this.formControlAdd(this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 一个剪切的方法
    splitSign(str) {
      let theArr = null;
      if (str.indexOf(",") > 0) {
        theArr = str.split(",");
      } else if (str.indexOf("，") > 0) {
        theArr = str.split("，");
      }
      return theArr;
    },
    //添加控件
    formControlAdd(data) {
      let formData = { ...data };
      // console.log(formData);
      //数据处理
      switch (formData.choose) {
        case "0":
          formData.form_control_type = "select";
          formData.form_control_option = this.splitSign(
            formData.form_control_option
          );
          formData.arr = formData.form_control_option.map((item, index) => {
            return {
              label: item,
              value: String(index)
            };
          });
          break;
        case "1":
          formData.form_control_type = "date";
          break;
        case "2":
          formData.form_control_type = "number";
          break;
        default:
      }
      formData.must_complete == true
        ? (formData.must_complete = 1)
        : (formData.must_complete = 2);

      //发送添加控件
      _formControlAdd({
        data: qs.stringify({
          form_control_name: formData.form_control_name, //控件的名称
          form_control_type: formData.form_control_type, //控件类型
          form_control_option: formData.form_control_option, //控件选项数组或者对象
          must_complete: formData.must_complete, //必填,1:必填;2:非必填
          is_default: formData.is_default //设置表单时是否默认 1:默认 0:正常
        })
      }).then(res => {
        if (res.resultCode == 1) {
          // console.log(res);
          formData.id = res.result.form_control_id;
          this.$message.success(res.errorMsg);
        } else {
          this.$message.success(res.errorMsg);
        }
      });
    },
    //删除控件
    delDefInfo(item) {
      _formControlRemove({
        params: {
          id: item.form_control_id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.initControlList();
        } else {
          this.$message.success(res.errorMsg);
        }
      });
    },
    //获取默认的信息
    initControlList() {
      _formControlList({}).then(res => {
        if (res.resultCode == 1) {
          let data = res.result;
          data.forEach((item, i) => {
            item.value = "";
            if (item.form_control_id == "13") {
              item.arr = item.form_control_option.map((loc, index) => {
                return {
                  label: index,
                  value: loc[index]
                };
              });
            }
          });
          this.def_data = data;
          // console.log(this.def_data);
        } else {
          this.$message.success(res.errorMsg);
        }
      });
    }
  }
};
</script>


<style lang="less" scoped>
.add-lockcourse {
  padding: 20px;
  background: #ffffff;
  min-height: 600px;
  .wrapper {
    max-width: 1000px;
    .add {
      .info-template {
        background: #f5f7fa;
        padding: 20px 0 20px 20px;
        .options {
          width: 320px;
          margin-left: 30px;
        }
      }
      .info-add {
        background: #efefef;
        padding: 10px 0 20px 20px;
      }
    }
    .all-info {
      .base-show {
      }
      .space {
        width: 95%;
        height: 1px;
        background: rgba(216, 220, 226, 1);
        margin: 10px 0;
      }
      i {
        cursor: pointer;
      }
    }
  }
}
</style>
